import React from 'react'
import { FormattedDate, FormattedTime, useIntl } from 'react-intl'
import { selectUnit } from '@formatjs/intl-utils'
import { Link } from 'react-router-dom'
import { Icon } from '@arnsbogroup/react-voicearchive'

const AuditionScopeOverview = ({ timestamp, body, title, last, orderId, meta }) => {
  const { hasBuyouts } = meta

  if (!hasBuyouts) {
    return null
  }

  return (
    <li>
      <div className="relative pb-8">
        <div className="relative flex items-start space-x-3">
          <div>
            <div className="relative px-2 mt-2">
              <div className="h-6 w-6 bg-positive rounded-full ring-4 ring-white flex justify-center items-center">
                <Icon icon={["fas", "eye"]} className="text-xs text-white" />
              </div>
            </div>
          </div>

          <div className="min-w-0 flex-1 py-0">
            <div className="text-sm leading-6">
              <div className="border border-gray-200 rounded-sm mb-2">
                <div className="p-2 flex justify-between items-center">
                  <span>{ title }</span>

                  <Link to={`/orders/${orderId}/overview`}>
                    <a className="ml-2 text-primary cursor-pointer hover:text-primary-darker">
                      Open <Icon icon={["fas", "external-link"]} />
                    </a>
                  </Link>
                </div>
                <p className="p-2 border-t border-gray-200">
                  We have prepared an overview page with your auditions, where you can see all the relevant information.
                </p>
              </div>

              <span className="whitespace-nowrap text-gray-500 text-xs">
                <FormattedDate value={timestamp * 1000} /> <FormattedTime value={timestamp * 1000} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </li>
  )
}

export default AuditionScopeOverview
